var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"padding-top":"0 !important"}},[_c('default-header',[_c('template',{slot:"title"},[_vm._v(_vm._s(_vm.$t('menu.about.team')))])],2),_c('respondeco-about-us')],1)}
var staticRenderFns = []

export { render, staticRenderFns }